import request from "@/utils/request";
//物料信息设定

//查询
export var getData = function getData(data) {
  return request({
    url: "/api/WIP/SSCHOrder/QueryOrderList",
    method: "POST",
    data: data
  });
};

//删除详细页面中的产品
export var deleteData = function deleteData(data) {
  return request({
    url: "/api/WIP/SSCHOrder/DeleteOrder",
    method: "POST",
    data: data
  });
};
//查询详细信息
export var getDetailData = function getDetailData(data) {
  return request({
    url: "/api/WIP/SSCHOrder/GetOrder/".concat(data.OrderKey),
    method: "GET"
  });
};
//通过OrderId查询详细信息
export var GetOrderById = function GetOrderById(data) {
  return request({
    url: "/api/WIP/SSCHOrder/GetOrderById",
    method: "GET",
    data: data
  });
};
//删除详细页面中的产品
export var deleteDetailProductData = function deleteDetailProductData(data) {
  return request({
    url: "/api/WIP/SSCHOrder/DeleteOrderItem",
    method: "POST",
    data: data
  });
};
//新增编辑
export var saveOrderList = function saveOrderList(data) {
  return request({
    url: "/api/WIP/SSCHOrder/SaveOrderList",
    method: "POST",
    data: data
  });
};
//根据产品key获取BOM
export var GetItemBom = function GetItemBom(data) {
  return request({
    url: "/api/BasicData/SBRMItemBom/GetItemBom",
    method: "POST",
    data: data
  });
};
//
//客户查询
export var GetCustomerLlist = function GetCustomerLlist(data) {
  return request({
    url: "/api/BasicData/sbrmcustomer/QueryCustomerLlist",
    method: "POST",
    data: data
  });
};
//产品查询
export var GetProductList = function GetProductList(data) {
  return request({
    url: "/api/BasicData/SBRMProduct/QueryProductList",
    method: "GET",
    data: data
  });
};
//生成订单号
export var GetOrderNo = function GetOrderNo(data) {
  return request({
    url: "api/system/BillRule/BillNumber/OrderNo",
    method: "GET",
    data: data
  });
};
//同意
export var orderAudit = function orderAudit(data, id) {
  return request({
    url: "/api/Wip/SSCHOrder/Approva/".concat(id),
    method: "POST",
    data: data
  });
};
//拒绝
export var orderReject = function orderReject(data, id) {
  return request({
    url: "/api/workflow/Engine/FlowBefore/Reject/".concat(id),
    method: "POST",
    data: data
  });
};

// BOMlist
export var BOMList = function BOMList(data, id) {
  return request({
    url: "/api/system/DataInterface/281648069823431941/Actions/Response",
    method: "GET",
    data: data
  });
};

// 内勤
export var confirmOrder = function confirmOrder(data) {
  return request({
    url: "/api/WIP/sschorder/ConfirmOrder",
    method: "GET",
    data: data
  });
};

// BOMlist
export var orderStatus = function orderStatus(data, id) {
  return request({
    url: "/api/system/DataInterface/282414165555938565/Actions/Response",
    method: "GET",
    data: data
  });
};